import React ,{useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const InstallationProvisioning = () => {

    const [accInfo, setAccInfo] = useState('')
    const navigate = useNavigate();
    const redirectInstallationPage = () => {
      navigate("/installation");
    };

    const redirectToWCR = () => {
      navigate("/installationWCR");
    }

    const redirectToIR = () =>{
      navigate("/installationIR");
    }
    const redirectToWCRCompleted = () => {
      navigate("/InstallationWCRCompleted");
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
            //   setLoading(true);
              const apiUrl = process.env.REACT_APP_API_URL;
              const requestData = {
                "Action": "updateWCREngineer",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f", 
                "AppointmentDate" : sessionStorage.getItem('AppointmentDate'),
                "EngName" :sessionStorage.getItem('name'),
                "Instcode":"",
                "WCRguidId":sessionStorage.getItem('WCRguidId')
                 
            };
              const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
              });
              if (response.ok) {
                const result = await response.json();
                // console.log('API Response:', result);
                
                if (result && result.Response && result.Response.Status !== "Failure" ) {
                  //console.log('Actual Data:', result.Response.Data);
                  // console.log('updateWCREngineer',result.Response);
                 
                } else {
                  const errorMessage = (result && result.Response && result.Response.Message);
                  toast.warning(`${errorMessage}`, {
                    position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                });
                // console.log(errorMessage);
                }
              } else {
                console.error('Error fetching data:', response.status);
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            } finally {
            //   setLoading(false);
            }
          };
         
        fetchData();
          
      }, []);

      useEffect(() => {
        const fetchDataupdateAppointment = async () => {
            try {
            //   setLoading(true);
              const apiUrl = process.env.REACT_APP_API_URL;
              const requestData = {
                "Action": "updateAppointment",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f", 
                "AppointmentDate" : sessionStorage.getItem('AppointmentDate'),
                "OrderID" : sessionStorage.getItem('OrderID')
                 
            };
              const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
              });
              if (response.ok) {
                const result = await response.json();
                // console.log('API Response:', result);
                
                if (result && result.Response && result.Response.Status !== "Failure" ) {
                  //console.log('Actual Data:', result.Response.Data);
                  // console.log('updateAppointment',result.Response);
                 
                } else {
                  const errorMessage = (result && result.Response && result.Response.Message);
                //   toast.warning(`${errorMessage}`, {
                //     position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                // });
                }
              } else {
                console.error('Error fetching data:', response.status);
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            } finally {
            //   setLoading(false);
            }
          };
         
          fetchDataupdateAppointment();
          
      }, []);

      useEffect(() => {
        const fetchDatagetAccountInfo = async () => {
            try {
            //   setLoading(true);
              const apiUrl = process.env.REACT_APP_API_URL;
              const requestData = {
                "Action": "getAccountInfo",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f", 
                "CanId" : sessionStorage.getItem('CanId'),
                "OrderId" : sessionStorage.getItem('OrderID')
                 
            };
              const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
              });
              if (response.ok) {
                const result = await response.json();
                // console.log('API Response:', result);
                
                if (result && result.Response && result.Response.Status !== "Failure" ) {
                  //console.log('Actual Data:', result.Response.Data);
                  sessionStorage.setItem('StatusofReport', result.Response.StatusofReport);
                  // console.log('getAccountInfo',result.Response);
                  setAccInfo(result.Response)
                } else {
                  const errorMessage = (result && result.Response && result.Response.Message);
                  toast.warning(`${errorMessage}`, {
                    position: toast.POSITION.BOTTOM_CENTER,autoClose: 1500
                });
                // console.log(errorMessage);
                }
              } else {
                console.error('Error fetching data:', response.status);
              }
            } catch (error) {
              console.error('Error fetching data:', error);
            } finally {
            //   setLoading(false);
            }
          };
         
          fetchDatagetAccountInfo();
          
      }, []);

      const redirectToProvisioningForm = (e) =>{

        // console.log('Provi',e);
           sessionStorage.setItem("provisioningCANID",e.CANID);
        
          navigate("/installationprovisioningform")
       }


    return (
        <>

<div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span className="" style={{ cursor: "pointer" }} onClick={redirectInstallationPage}>
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Provisioning</span>
        </div>
        
      </div>
 
      <div className='container-fluid' style={{marginTop:"65px"}}>
                  <div className="row justify-content-center">
              
                    
                    <div className="col-12 col-md-6">
                      <div className="card mb-3 mx-auto">
                        <div className="p-2 card-data">
                          <div>
                          <div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color">Can ID </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.CANID}</div>
                          </div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color">Customer Name </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.Name}</div>
                          </div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color">City </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.City}</div>
                          </div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color">Area Name </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.Area}</div>
                          </div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color" style={{whiteSpace:"nowrap"}}>Building/Society</div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.Society}</div>
                          </div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color">Segment </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.Segment}</div>
                          </div>
                          <div className="row mt-1">
                          <div className="col-5 text-weight-color">Address </div>
                          <div className="col-1">:</div>
                          <div className="col-6">{accInfo.Address}</div>
                          </div>
                          {/* <p className="provision-card-text">Can ID : {accInfo.CANID} </p>
                          <p className="provision-card-text">Customer Name : {accInfo.Name} </p>
                          <p className="provision-card-text">City : {accInfo.City} </p>
                          <p className="provision-card-text">Area Name :  {accInfo.Area}</p>
                          <p className="provision-card-text">Building/Society : {accInfo.Society} </p>
                          <p className="provision-card-text">Segment : {accInfo.Segment}</p>
                          <p className="provision-card-text" style={{lineHeight:"18px"}}>Address : {accInfo.Address}</p> */}
                          </div>
                          <div className="row mt-5">

                          <div className=" col-6 text-center ">
                                <button
                                    type="submit"

                                    className="btn text-light w-100 Provision-btn mx-auto rounded-pill"
                                    //  onClick={redirectToProvisioning}
                                    onClick={() => redirectToProvisioningForm(accInfo)}
                                >
                                    Provisioning
                                </button>
                            </div>
                            { accInfo.Segment == "Home" && <div className="col-6 text-center ">
                                <button
                                    type="submit"
                                    className="btn text-light w-100 bg-dark mx-auto rounded-pill"
                                     onClick={redirectToWCR}
                                >
                                    WCR
                                </button>
                            </div>}

                            {(accInfo.StatusofReport == "Installation Completed" || accInfo.StatusofReport =="Completed") &&
                            <>
                            {accInfo.Segment == "Business" && (
                             <div className="col-6 text-center ">
                              
                                <button
                                    type="submit"
                                    className="btn text-light w-100 bg-dark mx-auto rounded-pill"
                                     onClick={redirectToIR}
                                >
                                    IR
                                </button>
                               
                            </div>
                              )}
                               {accInfo.StatusofReport == "Completed" && (
                             <div className="col-6 text-center ">
                              
                                <button
                                    type="submit"
                                    className="btn text-light w-100 bg-dark mx-auto rounded-pill  m-2"
                                     onClick={redirectToWCRCompleted}
                                >
                                    WCR Completed
                                </button>
                               
                            </div>
                              )}
                            </>
                            }
                            </div>
                        </div>
                      </div>
                    </div>
                    </div>
                    
                 
             
                  </div>
                </div>
        </>
    )

};

export default InstallationProvisioning;